import React, { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from "../../models/stores/actions";
import { isNormalZhEnCss, getOuterHeight } from '../../utils'
import styles from './styles.module.scss';

const Index = memo(() => {

  const dispatch = useDispatch();
  const { telModelDventHidden } = actions;


  const recReSizeReducer = useSelector(({ recReSizeReducer }) => recReSizeReducer.value);
  const { layouts, lang } = useSelector(({ localesReducer }) => localesReducer.i18n);
  const {telModelVisible} = useSelector(({basicDrawerReducer}) => basicDrawerReducer);

  // 样式判断
  const normal = () => {
    if (recReSizeReducer > 1920) {
      return styles.normalXl2;
    }

    if (recReSizeReducer > 1440 && recReSizeReducer <= 1920) {
      return styles.normalXl;
    }

    if (recReSizeReducer > 1024 && recReSizeReducer <= 1440) {
      return styles.normalLg;
    }

    if (recReSizeReducer > 750 && recReSizeReducer <= 1024) {
      return styles.normalMd;
    }

    if (recReSizeReducer <= 750) {
      return styles.normalSm;
    }
  };

  // 判断是：桌面/移动端
  const isDesktopMobile = () => {
    const {
      tel,
    } = layouts.footerData;
    return (
      <div className='telModel'>
        <div className='content'>
          <svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="948.000000pt" height="1280.000000pt" viewBox="0 0 948.000000 1280.000000" preserveAspectRatio="xMidYMid meet">
            <g transform="translate(0.000000,1280.000000) scale(0.100000,-0.100000)" fill="#838181" stroke="none">
            <path d="M3102 12793 l-23 -5 5 -151 c3 -84 8 -348 11 -587 17 -1352 53 -2558
            85 -2790 7 -52 14 -70 36 -89 26 -21 34 -23 108 -19 46 3 109 15 146 28 91 31
            253 114 325 165 67 47 177 159 273 278 l64 78 -1 267 c-1 147 -3 364 -6 482
            -3 118 -10 573 -16 1010 l-10 795 -30 61 c-20 43 -52 83 -106 135 -235 224
            -639 384 -861 342z"/>
            <path d="M2605 12779 c-291 -27 -655 -104 -914 -194 -860 -300 -1410 -854
            -1606 -1620 -68 -266 -80 -377 -79 -770 2 -615 50 -1339 134 -2015 193 -1539
            580 -2865 1091 -3735 82 -140 352 -549 575 -870 1139 -1644 2196 -2695 3236
            -3216 650 -327 1335 -437 1873 -303 369 92 802 237 1155 386 267 113 811 400
            810 426 -1 4 -370 297 -822 652 -452 355 -1111 873 -1464 1151 l-643 505 -98
            -48 c-312 -154 -646 -188 -900 -93 -133 50 -265 145 -365 262 -220 256 -765
            1222 -1595 2823 -465 897 -721 1411 -747 1505 -121 430 -71 809 144 1094 98
            129 214 225 384 318 l90 48 -3 110 c-1 61 -24 868 -51 1795 -28 927 -50 1711
            -50 1743 l0 57 -32 -1 c-18 -1 -73 -5 -123 -10z"/>
            <path d="M6603 3668 c-221 -117 -402 -216 -403 -219 0 -8 2990 -2383 3005
            -2387 10 -3 97 255 222 658 41 134 48 167 48 241 0 81 -2 90 -43 172 -26 53
            -65 111 -99 148 -95 102 -1506 1203 -1813 1414 -155 106 -315 170 -453 181
            l-62 4 -402 -212z"/>
            </g>
          </svg>
          <a href={`tel:${tel}`}>{tel}</a>
        </div>
        <div className='close' onClick={() => dispatch(telModelDventHidden())}>{isNormalZhEnCss(lang, 'English') ? 'Cancel' : '取消'}</div>
      </div>
    );
  };


  const telRenderCom = () => {
    return telModelVisible ? (
      <div className={normal()} style={{height: getOuterHeight(), overflow: 'hidden'}}>
        {isDesktopMobile()}
      </div>
    ) : null;
  }

  return recReSizeReducer <= 750 ? telRenderCom() : null;


  
});
export default Index;
